<template lang="pug">
.gzzoc-pdf-wrapper
    .gzzoc-pdf
        img.logo(src="~public/images/gzzoc/logo-pdf.png", width="267")
        .title
            | {{$t('gzzoc.reportTitle')}}
        .person
            .item
                |{{$t('gzzoc.name')}}：{{result.name}}
            .item
                |{{$t('gzzoc.gender')}}: {{result.gender}}
            .item
                |{{$t('gzzoc.age')}}: {{result.age}}

        .capture-dom(v-if="showCapture")
        .result-wrapper.thin-border-top
            .result-content(v-for='(item, index) in result.report')
                .eye-box(v-if="item.img && item.img.length")
                    .eye(v-for="i in item.img")
                        img.eye-img(:src="imgsrc(i.img)", @load="didLoadImg")
                        .name {{i.explain}}
                .result-item(v-if="item.diagnosis && item.diagnosis[0]")
                    .result-title {{item.diagnosis[0].title}}
                    .result-description.has-big-font
                        label {{item.diagnosis[0].explain}}

        .result-sign(:class="langClass")
            .result-data
                span.label {{$t('gzzoc.date')}}:
                span.value {{date}}
</template>

<script>
import _ from 'lodash';
import { languages, loadLanguageAsync } from "@/locale";
// import testData from './gzzoc-hepatobiliary-mock';

export default {
    data () {
        return {
            result: {
                report: []
            },
            imgLoadCount: 0,
            showCapture: false
        };
    },
    computed: {
        id () {
            return this.$route.params.taskId;
        },
        date () {
            return this.$route.params.date;
        },
        lang () {
            return _.find(languages, {lang: this.$i18n.locale}) || languages[0];
        },
        langClass () {
            return {
                'en': this.lang.lang === 'en'
            };
        }
    },
    async mounted () {
        // webshot在截取页面时需要先将页面渲染出来，在后端渲染页面时会丢失用户在浏览器端设置的语言信息
        // 所以将语言信息放在路径中，渲染页面从路径中取出预测结果页要显示的语言，并进行设置
        // 这样就能正常使用 i18n 的功能了
        let lang = _.get(this.$route, 'params.lang');
        if (lang) {
            await loadLanguageAsync(lang);
        }
        this.getResult();
    },
    methods: {
        imgsrc (src) {
            return '/api/upl/s3/download/big/file?_id=' + src;
        },
        didLoadImg () {
            this.imgLoadCount++;
        },
        getResult () {
            this.$http.get('/api/mli/predict_model/task_result', {
                params: {
                    task_id: this.id,
                    lang: this.lang.lang
                }
            }).then(resp => {
                const status = _.get(resp, 'body.value.data.status');
                // 成功
                if (status === 'completed') {
                    const result = _.get(resp, 'body.value.data.results', {});
                    this.result = result;
                    return;
                }
            }).finally(() => {
                let reports = this.result.report || [];
                let total = 0;
                for (let i = 0; i < reports.length; i++) {
                    let report = reports[i];
                    total += (report.img || []).length;
                }
                // 解决截图中存在loading状态的bug
                this.$nextTick(() => {
                    setTimeout(() => {
                        this.doShowCapture(total);
                    }, 500);
                });
            });
        },
        // 需要等图片都出来后，再截图
        doShowCapture (total) {
            if (this.imgLoadCount === total) {
                this.showCapture = true;
            } else {
                setTimeout(() => {
                    this.doShowCapture(total);
                }, 500);
            }
        }
    }

};
</script>

<style lang="sass" scoped>
// gzzoc-pdf-wrapper 是为了防止 gzzoc-pdf 缩小后，露出带有图案的背景
// 各边增加1px，防止出现线条
.gzzoc-pdf-wrapper
    width: calc(100% + 2px)
    height: calc(100% + 2px)
    transform: translate(-1px, -1px)
    background-color: #FFF
    overflow-y: hidden
.gzzoc-pdf
    background-color: #FFF
    margin: 0 auto
    color: #000
    // 为了将预测结果在一页中打印出来，将页面以顶部中心为原点，缩小80%
    transform-origin: top center
    transform: scale(0.8, 0.8)
    .logo
        width: 196px
        height: 28px
    .title
        font-family: STSongti-SC-Black
        font-size: 24px
        line-height: 24px
        text-align: center
        margin-top: 21px
        white-space: pre-wrap
    .person
        font-family: STSongti-SC-Regular
        font-size: 12px
        color: #000000
        line-height: 12px
        padding-top: 20px
        padding-bottom: 15px
        display: flex
        justify-content: center
        .item
            display: inline-block
            margin: 0 30px
    .result-wrapper
        display: flex
        flex: 1 1
        justify-content: center
        padding-top: 20px
        .result-content
            width: 100%
        .eye-box
            display: flex
            flex-wrap: wrap
            justify-content: space-around
            padding-bottom: 24px
            .eye
                height: 330px
                margin-top: 24px
                display: flex
                flex-direction: column
                .eye-img
                    width: 300px
                    height: 300px
                    margin: 0px 12px
                    background-color: #F9F9F9
                    object-fit: scale-down
                .name
                    font-family: STSongti-SC-Regular
                    font-size: 12px
                    height: 14px
                    line-height: 14px
                    color: #000000
                    text-align: center
                    margin-top: 10px
        .result-item
            padding-top: 10px
            padding-bottom: 10px
            border-top: 1px solid #999
            &:first-child
                padding-top: 20px
            &:last-child
                padding-bottom: 0px
            .result-title
                font-family: STSongti-SC-Regular
                font-size: 12px
                line-height: 17px
                color: #000
            .result-description
                font-family: STSongti-SC-Regular
                font-size: 12px
                color: #000
                margin-top: 5px
                vertical-align: top
                &.has-big-font
                    label:first-child
                        font-size: 18px
                        line-height: 25px
                        display: block
                        width: 100%
            .result-small-text
                font-size: 12px
                line-height: 20px

    .result-sign
        float: right
        font-family: PingFangSC-Regular
        font-size: 12px
        color: #666
        line-height: 24px
        width: 210px
        margin-top: 20px
        margin-bottom: 10px
        .result-data
            text-align: right
        &.en
            width: 200px
        .result-doctorSignature
            img
                width: 147px
                height: 24px
                transform: translateY(2px)
        .label
            margin-right: 5px
        .value
            color: #333
    .tips
        clear: both
        padding: 25px 0
        font-family: STSongti-SC-Regular
        font-size: 10px
        line-height: 14px
        color: #000
        .tip-content
            margin-top: 5px
        .tip-warm
            margin-top: 10px
</style>
